/**
 * Module for header on Price Lookup page
 * @module src/PriceLookupHeader
 */
import React, { FC, ReactNode } from 'react';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import PageHeader from '@salesforce/design-system-react/components/page-header';
import PageHeaderControl from '@salesforce/design-system-react/components/page-header/control';
import Button from '@salesforce/design-system-react/components/button';
import { getEventIcon } from '../../util/utilityFunctions';
import { ORDERS } from '../../util/constants';

interface Props {
  label: string;
  handleOrderSearch: () => void;
  Reset: () => void;
}

const PriceLookupHeader: FC<Props> = ({ label, handleOrderSearch, Reset }) => {
  const headerControls = (): ReactNode => (
    <>
      <PageHeaderControl className="slds-m-left_large">
        <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
          <div className="slds-col_padded">
            <Button label="Reset" onClick={Reset} />

            <Button label="+ New" onClick={handleOrderSearch} />
          </div>
        </div>
      </PageHeaderControl>
    </>
  );

  const iconPath = getEventIcon(ORDERS);

  return (
    <div>
      <IconSettings iconPath="/icons">
        <PageHeader
          className="events_header"
          icon={<img src={iconPath} className="logo-image" alt="Price Lookup" />}
          label={label}
          title="Price Lookup"
          onRenderControls={headerControls}
          truncate
          variant="object-home"
        />
      </IconSettings>
    </div>
  );
};

export default PriceLookupHeader;
